export function isEmptyObject(testObj) {
  let empty = true
  if (typeof testObj === 'object') {
    if (Object.keys) {
      empty = Object.keys(testObj).length === 0
    } else {
      // eslint-disable-next-line
      for (let _ in testObj) {
        empty = false
        break
      }
    }
  }
  return empty
}

export function extend (a, b) {
  for (const key in b) {
    a[key] = b[key]
  }
  return a
}

export function isDef (v) {
  return !(v === undefined || v === null)
}


// WEBPACK FOOTER //
// ./src/utils/misc.js